import { useCallback } from 'react';

const RadioButton = ({ checked, action }: { checked: boolean; action: () => void }) => {
  const handleClick = useCallback(() => {
    action();
  }, [action]);

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={handleClick}
      className={`ml-3 h-[20px] w-[38px] rounded-full transition ${checked ? 'bg-[#00965f]' : 'bg-black/90'}`}
    >
      <span
        className={`block h-[14px] w-[14px] rounded-full bg-white shadow transition-transform duration-100 will-change-transform ${
          checked ? 'translate-x-[21px]' : 'translate-x-[3px]'
        }`}
      />
    </button>
  );
};

export default RadioButton;
